'use strict';
const _ = require('underscore');
const UnkownNotification = require('notify/domain/entity/notification/unknown');

const Factory = class {
    constructor() {
        this._typeClasses = {};
    }

    build(type, json) {
        const klass = this._typeClasses[type];
        if(!klass) {
            return new UnkownNotification(json);
        }

        return new klass(json);
    }

    register(notificationClass) {
        const klass = this._typeClasses[notificationClass.type];
        if(klass) {
            throw `Notification Class of type: ${notificationClass.type} is already registered!`;
        }

        this._typeClasses[notificationClass.type] = notificationClass;
    }
};

const factory = new Factory();

_.each([
    require('notify/domain/entity/notification/action/assigned'),
    require('notify/domain/entity/notification/action/unassigned'),
    require('notify/domain/entity/notification/action/update'),
    require('notify/domain/entity/notification/action/start'),
    require('notify/domain/entity/notification/action/end'),
    require('notify/domain/entity/notification/actionwork/create'),
    require('notify/domain/entity/notification/actionwork/update'),
    require('notify/domain/entity/notification/task/create'),
    require('notify/domain/entity/notification/task/update'),
    require('notify/domain/entity/notification/comment/create-project'),
    require('notify/domain/entity/notification/comment/create-action'),
    require('notify/domain/entity/notification/comment/create-dataset'),
    require('notify/domain/entity/notification/comment/create-data-content'),
    require('notify/domain/entity/notification/create-user-request-comment'),
    require('notify/domain/entity/notification/create-idea-comment'),
    require('notify/domain/entity/notification/idea-release'),
    require('notify/domain/entity/notification/project/assigned'),
    require('notify/domain/entity/notification/project/start'),
    require('notify/domain/entity/notification/project/end'),
    UnkownNotification,
], klass => factory.register(klass));


module.exports = factory;



// WEBPACK FOOTER //
// ./notify/domain/factory/notification.js